import { React, Locale } from '../../libraries/index';
import { Modal } from 'react-bootstrap';

const DynamicContentModal = ({
    showModal,
    handleClose,
    message
}) => {
    const { t } = Locale();
    return (
        <>

            <Modal
                show={showModal}
                onHide={() => handleClose()}
                dialogClassName="custom-modal"
            >
                <Modal.Header
                    closeButton
                    className="headerLine"
                    onClick={() => handleClose()}
                />
                <Modal.Body>
                    <div className="text-center">
                        <div className='desc-heading-outer'>
                            <div className='desc-heading-inner'>
                                <p className="desc-message mt-1">
                                    <div className='message'>
                                        {message}
                                    </div>
                                </p>
                            </div>
                        </div>

                    </div>
                </Modal.Body>
            </Modal>


        </>
    );
};

export default DynamicContentModal;
